import { type RefObject, useEffect } from 'react'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export const useScrollLock = (ref: RefObject<HTMLElement | null>, locked: boolean) => {
  useEffect(() => {
    const el = ref.current
    if (!el) return
    if (locked) {
      disableBodyScroll(el)
    } else {
      enableBodyScroll(el)
    }
    return () => enableBodyScroll(el)
  }, [ref, locked])
}
